<template>
	<div class="main-bg">
		<div class="main">
			<div class="content">
				<remote-js src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></remote-js>
				<div class="left">
					<img src="../img/ic12.png" class="img-1" />
					<div class="desc">
						<p class="font-4">『国家记忆』栏目大型纪录片</p>
						<p class="font-4">中央广播电视总台中文国际频道</p>
						<img src="../img/ic13.png" class="img-2" />
					</div>
				</div>
				<div class="video">
					<div class="video-bg">
						<div class="prism-player" id="J_prismPlayer" :key="index"></div>
					</div>
					<div class="an font-4">
						<div class="an-bg" @click="index = 0">
							<span>
								第一集
								<font>《办校风云》</font>
							</span>
						</div>
						<div class="an-bg" @click="index = 1">
							<span>
								第二集
								<font>《自强不息》</font>
							</span>
						</div>
						<div class="an-bg" @click="index = 2">
							<span>
								第三集
								<font>《凤凰花开》</font>
							</span>
						</div>
					</div>
				</div>
				<div class="news font-4" v-show="index == 0">
					<h1>第一集《办校风云》</h1>
					<p>十九世纪末二十世纪初，满清政府风雨飘摇，国难深重，民不聊生。爱国华侨陈嘉庚先生亲身感受到满清政府的腐朽落后，开始了“教育救国”的实践，先后创办了一系列学校，统称集美学校。1919年爆发的“五四”运动，让陈嘉庚看到了新的希望，他决意在兴办集美学校的基础上，创办一所培养社会所急需的各种专业人才的高等学府——厦门大学。</p>
					<p>为了办好厦门大学，陈嘉庚散尽家财、呕心沥血：他与地方军阀斗智斗勇，为厦大选址演武场；他驳斥蔡元培“厦大不宜速办”言论，力排众议，借集美学校校舍举办厦大开学式；他亲选“国耻日”带领师生为首批校舍奠基；他凭一己之力，独资支撑厦门大学16年，甚至于卖掉自己的大厦，来支持厦大。当他的企业遭遇世界经济危机每况愈下，最后不得不收盘，再也无力支持厦大时，陈嘉庚毅然无条件地将学校献给国家。</p>
					<p>从1921年至1937年，林文庆担任厦门大学校长，他弘扬陈嘉庚精神，立志把厦大“办成一生的非死的、真的非伪的、实的非虚的大学”。这16年，林文庆为厦大开创了基业，使厦大迅速成为全国闻名的私立大学。</p>
				</div>
				<div class="news font-4" v-show="index == 1">
					<h1>第二集《自强不息》</h1>
					<p>1937年，抗日战争全面爆发，厦门大学改归国立，就在卢沟桥事变的前一天，清华大学教授萨本栋临危受命，接任厦门大学校长。面对日寇的步步进逼，萨本栋校长认为，厦门大学一定要坚守福建，屹立在敌人面前，展现中国人的志气，也让东南的青年有书读。于是，经过多方考虑，厦门大学选择内迁闽西长汀。</p>
					<p>1937年年底，厦大师生向长汀进发，1938年1月，厦门大学在长汀复课。厦门大学因此成为当时粤汉铁路线以东仅有的国立大学，也是最逼近战区的国立大学，撑起了中华民族高等教育的东南半壁。</p>
					<p>在长汀办学的8年中，萨本栋校长身先士卒、舍身治校，像一台永动机，激励着全体师生艰苦奋斗，他用健康乃至生命换来了学校的发展。全体师生充分发扬自强不息的精神，克服重重困难，厦门大学不仅没有被日寇压垮，反而声誉日隆，在1940年和1941年国民政府教育部举办的“全国专科以上学校学生学业竞赛”上，连续两年夺得全国冠军，在艰难困苦中铸就了“南方之强”的辉煌。</p>
					<p>抗战时期，陈嘉庚时刻关心着祖国抗日战况，他带领南洋各界为祖国抗战筹资捐款，派遣侨胞回国参战。1940年，他率领“南洋华侨回国慰劳考察团”回国慰问，对厦大的发展甚感欣慰。也就在这年，国民政府有意将厦门大学改名为福建大学，遭到了陈嘉庚和全体厦大师生的极力反对；也就在这年，陈嘉庚先后访问了重庆和延安，经过对比，他坚定地指出：“中国的希望在延安！”</p>
				</div>
				<div class="news font-4" v-show="index == 2">
					<h1>第三集《凤凰花开》</h1>
					<p>新中国成立后，陈嘉庚回到大陆定居，他没有应邀留在北京，而是决定定居厦门。</p>
					<p>回到家乡的陈嘉庚，十分兴奋地描绘着厦门大学的崭新蓝图。他成立了厦门大学建筑部，亲自负责学校的扩建，在女婿李光前的捐助下，扩建了25幢新校舍，总面积相当于新中国成立前全校建筑面积的一倍。</p>
					<p>1950年，中央政府任命著名的马克思主义经济学家王亚南为厦门大学校长。王亚南执掌厦大期间，十分注重发展学校的科研能力。在他的带领下，厦大师生“面向东南亚华侨、面向海洋”，科研激情迸发，开展了一系列特色研究与创新研究，厦门大学向着新型的综合性大学发展。</p>
					<p>进入新世纪、走进新时代，厦门大学不断拓展着“侨台特海”新生态，形成了“海洋、海峡、海丝”的区位优势和办学特色，产出了一批有影响力的科研成果。</p>
					<p>回望百年，陈嘉庚不仅留给世人一所综合性大学，而且留下了宝贵的精神财富，他的名字将和他倾资兴学的传奇故事一起永载史册，在后人心目中树起一座不朽的丰碑。</p>
				</div>
			</div>
			<jm-nav></jm-nav>
		</div>
		<img src="../img/ic10.png" class="body-bg" />
	</div>
</template>
<script src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></script>
<script>
import jmNav from '../components/jm_nav.vue'
import remoteJs from '../components/remote_js.vue'
import $ from 'jquery'
export default {
	data() {
		return {
			index:0,
			video:[
				"https://vod.xmupress.com/6b7c83f8378f46899da608c52e131a2e/b08e9dc02fa743f4beacffefc98056a8.m3u8",
				"https://vod.xmupress.com/0d8bf067fddf4df18099dd2c0d9fdefa/328496d5e337432eb78872cecee8cdac.m3u8",
				"https://vod.xmupress.com/6c1bf65217d04880a0be2de20cdc99e5/5524d9dcae9542cdb25c396ad67edee8.m3u8"
			]
		}
	},
	mounted() {
		this.checkPlay()
	},
	methods: {
		checkPlay(){
			if(window.Aliplayer !== undefined)
				new Aliplayer({ id: "J_prismPlayer", autoplay: true, width:"100%", height:"100%", source : this.video[this.index], cover:'', isLive: false,rePlay: false, playsinline: true,preload: true,controlBarVisibility: "hover", useH5Prism: true,format:'m3u8', }); 
			else
				setTimeout(this.checkPlay,20)
		}
	},
	watch:{
		index(){
			$('.prism-player').empty()
			this.$nextTick(this.checkPlay)
		}
	},
	components:{
		jmNav,
		remoteJs
	}
}
</script>
<style scoped>
@import "https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css";
.main{
	background: rgba(255,255,255,.3);
	width: 70rem;
	margin: 0 auto;
	border-radius: .5rem;
	padding-bottom: 2rem;
	z-index: 2;
	position: fixed;
	left: 50%;
	margin-left: -35rem;
	top: 50%;
	transform: translateY(-50%);
}
.left{
	display: flex;
	flex-direction: column;
	align-items: center;
}
.left .img-1{
	display: flex;
	width: 5.5rem;
}
.left .desc{
	display: flex;
	align-items: center;
	padding-left: 2rem;
	margin-top: 2rem;
}
.left .desc p{
	writing-mode:tb-rl;
	color: #231815;
	font-size: 1rem;
	width: 1rem;
	margin-right: .5rem;
	height: 14rem;
}
.left .desc .img-2{
	display: flex;
	margin-left: 1rem;
	width: 4rem;
}
.main .content{
	padding-top: 1.5rem;
	display: flex;
	height: 31rem;
}
.main .p-1{
	color:#92443c;
	font-size: 1.4rem;
	writing-mode:tb-rl;
	margin-top:4rem;
	margin-left: 1.5rem;
}
.main .news{
	overflow-y: auto;
	height: 27.5rem;
	width: 22.5rem;
	margin-top: 2rem;
	padding-left: 2rem;
	padding-right:.5rem;
}
.main .news h1{
	color:#92443c;
	font-size: 1.2rem;
	margin-bottom: 1rem;
	text-indent: 2em;
}
.main .news p{
	color:#92443c;
	font-size: 1rem;
	line-height: 1.6rem;
	text-indent: 2em;
}
.video{
	margin-left: 2rem;
	margin-top: 2.5rem;
}
.video-bg{
	width: 32.45rem;
	height: 20.85rem;
}
.video .an{
	display: flex;
	justify-content: space-between;
	padding: 0 2.5rem;
	margin-top: 1rem;
}
.video .an .an-bg{
	width: 8.3rem;
	height: 4rem;
	padding: .5rem;
	background: #d7412a;
	border-radius: .15rem;
	cursor: pointer;
}
.video .an span{
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: .15rem;
	border:1px solid #c6af7b;
	color: #c6af7b;
	height: 100%;
	justify-content: center;
	font-size: 1.1rem;
}
.video .an font{
	font-size: 1.1rem;
	margin-top: .1rem;
}
.prism-player{
	width: 32.45rem;
	height: 20.85rem;
}
.body-bg{
	position: fixed;
	width: 100%;
	bottom: 0;
	left: 0;
}
</style>